"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.withAllDiscounts = exports.withElectronicDiscount = exports.withAutoPxDiscount = exports.withEmptyDiscounts = exports.baseTotal = void 0;
var mockDiscounts_1 = require("./mockDiscounts");
var Total_1 = require("../models/Total");
exports.baseTotal = __assign(__assign({}, Total_1.makeEmptyTotal()), { subTotal: 100, tax: 10, taxRate: 6, grandTotal: 106 });
exports.withEmptyDiscounts = __assign(__assign({}, exports.baseTotal), { discounts: [] });
exports.withAutoPxDiscount = __assign(__assign({}, exports.baseTotal), { discounts: [mockDiscounts_1.mockAutoPxDiscount] });
exports.withElectronicDiscount = __assign(__assign({}, exports.baseTotal), { discounts: [mockDiscounts_1.mockElectronicDiscount] });
exports.withAllDiscounts = __assign(__assign({}, exports.baseTotal), { discounts: [mockDiscounts_1.mockAutoPxDiscount, mockDiscounts_1.mockElectronicDiscount] });
//# sourceMappingURL=mockTotal.js.map